module.exports = __webpack_public_path__ + "static/media/championshipFinal.59fe786e.svg";